'use strict';

/**
 * @name core
 */

exports.HBNBVersion = require('./hbnb_version.js');
exports.supportApis = require('./support_apis.js');
exports.OSVersion = require('./os_version.js');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/core/index.js
// module id = 572
// module chunks = 0